import { Button, Modal } from "react-bootstrap"
import { Loaders } from "../../../pages/Loaders"
import { useState } from "react"
import { toast } from "react-toastify"
import { resetPasswodLink } from "../../apifile/ApiFiles"
import { useNavigate } from "react-router-dom"


const ResetPasswodTokenModel = (props) => {
    const navigate = useNavigate()
    const [loader, setLoader] = useState(false)
    const [initialVal, setInitialVal] = useState({
        password: "",
        confirmPassword: ""
    })
    const changeHandler = (e) => {
        const clone = { ...initialVal }
        const value = e.target.value
        const name = e.target.name
        clone[name] = value
        setInitialVal(clone)
    }
    const notify = (updateMassage) => toast(updateMassage);
    const submitData = async () => {
        setLoader(true)
        const clone = { ...initialVal, token: props?.params?.token }
        try {
            const res = await resetPasswodLink(clone)
            // console.log(res?.data);
            if (res?.data?.error == false) {
                notify('Password reset successfully!')
                setLoader(false)
                props.onHide()
                navigate('/login')
            } else {
                setLoader(false)
                alert(res?.data?.message)
            }
        } catch (error) {
            setLoader(false)
        }
    }
    return (
        <>
            {loader && <Loaders />}

            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Reset Password
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group   col-lg-12">
                        <label htmlFor="password" className="mb-2">
                            <strong>Password <span style={{ color: 'red' }}>*</span></strong>
                        </label>
                        <input
                            className="form-control"
                            placeholder="Enter Password !"
                            id="password"
                            type="password"
                            name="password"
                            value={initialVal.password}
                            onChange={changeHandler}
                        />
                    </div>
                    <div className="form-group   col-lg-12">
                        <label htmlFor="password" className="mb-2">
                            <strong>Confirm Password <span style={{ color: 'red' }}>*</span></strong>
                        </label>
                        <input
                            className="form-control"
                            placeholder="Enter Confirm Password !"
                            id="password"
                            type="password"
                            name="confirmPassword"
                            value={initialVal.confirmPassword}
                            onChange={changeHandler}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='btn-danger' onClick={props.onHide} style={{ width: '200px', height: '50px' }}>Close</Button>
                    <Button variant="primary" onClick={submitData} style={{ width: '200px', height: '50px' }}>Submit</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ResetPasswodTokenModel